// extracted by mini-css-extract-plugin
var _1 = "VersionMismatchModal-module__container--oOQF4";
export { _1 as "container" }
